import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=cda74d60&scoped=true"
import script from "./DashboardCard.vue?vue&type=script&lang=js"
export * from "./DashboardCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda74d60",
  null
  
)

export default component.exports